import { apiGet } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { IKnmReasonChangeType } from '../interfaces/IKnmReasonChangeType';

export async function fetchKnmPlanReasonChangeTypes(): Promise<IKnmReasonChangeType[]> {
  return apiGet<IKnmReasonChangeType[]>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/erknm/knm-plan-reason-change-types`,
  );
}
